import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";
/**
 * Funcion para insertar una cotización
 * @param {*} data Los datos principales de la cotización
 * @param {*} details Los detalles de la cotización
 * @returns El id de la cotización registrada
 */
export const insertQuotes = async (data, details, dataCustomer,idOrderQuot=0) => {
  const {
    idUser,
    idStore,
    idTurn,
    idVoucher,
    idTypeOfSale,
    idTypeOfPayment,
    idCreditNote,
    total,
    totalWhitDiscount,
    igv,
    subTotal,
    otherDiscounts,
    totalCreditNote,
    totalCreditNoteDiference,
    discount,
    expireQuotation,
    comentary,
    totalPayableByInsurer,
    totalPayableByCustomer,
    userName,
    customerName,
    serieVoucher,
    numberVoucher,
    numberReference,
    currencyDescription,
    currencyPrefix,
    igvApplied,
    retention,
    entityBank,
    numberOperation,
    cashAmount,
    targetAmount,
    transferAmount,
    chequeAmount,
    customerAmountPaid,
    customerAmountReturned,
    modificationDate,
    sunatAnswer,
  } = data;
  try {
    const response = await axios.post(
      "venta-temporal-cotizacion-pedido",
      {
        idUser,
        idStore,
        idTurn,
        idVoucher,
        idTypeOfSale,
        idTypeOfPayment,
        idCreditNote,
        total,
        totalWhitDiscount,
        igv,
        subTotal,
        otherDiscounts,
        totalCreditNote,
        totalCreditNoteDiference,
        discount,
        expireQuotation,
        comentary,
        totalPayableByInsurer,
        totalPayableByCustomer,
        userName,
        customerName,
        serieVoucher,
        numberVoucher,
        numberReference,
        currencyDescription,
        currencyPrefix,
        igvApplied,
        retention,
        entityBank,
        numberOperation,
        cashAmount,
        targetAmount,
        transferAmount,
        chequeAmount,
        customerAmountPaid,
        customerAmountReturned,
        modificationDate,
        sunatAnswer,
        state: "VIGENTE",
        type: "COTIZACION",
        idCustomer: dataCustomer.id,
        details,
        delete_before:idOrderQuot
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.data;
    if (data.msg === true) {
      confirmationOfRecord(`La cotización del cliente <strong>${customerName}</strong>`);
      return data.id;
    } else {
      errorActions(
        `Lo sentimos no pudimos registrar la cotización del cliente <strong>${customerName}</strong> verifica si tuviste alguna problemas al momento de ingresar los productos o los datos del cliente`
      );
    }
  } catch (error) {
    errorActions(error);
  }
};
